/* Buffalo House quantity-aware card controls and review cleanup. */
(function () {
  'use strict';

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function cardQuantity(card) {
    var input = card && card.querySelector('[data-card-qty]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;
    if (input) input.value = quantity;
    return quantity;
  }

  function syncVariantQuantity(form) {
    var card = form && form.closest('.product-card');
    var hidden = form && form.querySelector('[data-card-variant-quantity]');
    if (hidden) hidden.value = cardQuantity(card);
  }

  document.addEventListener('click', function (event) {
    var optionButton = event.target.closest('[data-card-variant-submit]');
    if (!optionButton) return;

    event.preventDefault();
    var form = optionButton.closest('[data-card-variant-form]');
    if (!form || optionButton.disabled) return;

    var submitter = form.querySelector('[data-card-hidden-submit]');
    if (!submitter || submitter.disabled) return;

    syncVariantQuantity(form);
    optionButton.classList.add('is-loading');

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter);
    } else {
      submitter.click();
    }

    window.setTimeout(function () {
      optionButton.classList.remove('is-loading');
    }, 5000);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-card-variant-form]');
    if (form) syncVariantQuantity(form);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-card-qty]');
    if (!input) return;
    var value = parseInt(input.value, 10);
    input.value = value && value > 0 ? value : 1;
  });

  document.addEventListener('cart:updated', function () {
    all('[data-card-variant-submit].is-loading').forEach(function (button) {
      button.classList.remove('is-loading');
    });
    all('.pc-variant-tray.is-open').forEach(function (tray) {
      tray.classList.remove('is-open');
      var card = tray.closest('.product-card');
      if (!card) return;
      card.classList.remove('tray-open');
      var opener = card.querySelector('[data-open-tray]');
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
  });

  function cleanEmptyJudgeMeText() {
    all('.pdp-info-card .jdgm-prev-badge').forEach(function (badge) {
      var text = badge.querySelector('.jdgm-prev-badge__text');
      if (!text) return;
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (count === 0 || /no\s+reviews?/i.test(text.textContent || '')) {
        text.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanEmptyJudgeMeText, { once: true });
  } else {
    cleanEmptyJudgeMeText();
  }
  window.setTimeout(cleanEmptyJudgeMeText, 600);
  window.setTimeout(cleanEmptyJudgeMeText, 1800);
})();
